import React, { FC } from 'react';

import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const SearchIcon: FC<Props> = props => <AbstractIcon {...props} icon={faMagnifyingGlass} />;

export { SearchIcon };